type DetailSubFormHeaderProps = {
  title: string
}

export const DetailSubFormHeader = ({ title }: DetailSubFormHeaderProps) => {
  return (
    <h3 className="rounded bg-blue-400 p-2 text-sm font-medium leading-none text-white">
      {title}
    </h3>
  )
}
